import React from 'react';

import Cancel from 'components/Shared/icons/cancel';
import Featured from 'components/Shared/icons/featured';

interface SuccessMessagePopupCardProps {
    Title?: string;
    Subtitle?: string;
    Description?: string;
    setPopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SuccessMessagePopupCard = ({
    Title,
    Subtitle,
    Description,
    setPopupOpen
}: SuccessMessagePopupCardProps) => {
    return (
        <div className='max-w-[600px] rounded-lg p-6 flex flex-col items-start gap-2 bg-white z-30'>
            {/* icons, close icon */}
            <div className='flex items-start justify-between w-full gap-2'>
                <div className='flex items-center justify-center w-10 h-10 rounded-full bg-neutral-50'>
                    <Featured />
                </div>

                <button
                    type="button"
                    onClick={() => setPopupOpen(false)}
                    aria-label="Close success message"
                    className="cursor-pointer flex items-center justify-center w-fit p-0.5 hover:!bg-[#edebea] transition-colors rounded"
                >
                    <Cancel color="#161616" aria-hidden={true} />
                </button>
            </div>

            {/* success message */}
            {Title && (
                <p className='font-semibold text-lg text-neutral-800'>
                    {Title}
                </p>
            )}

            {Subtitle && (
                <p className='font-semibold text-lg text-neutral-800 mt-4'>
                    {Subtitle}
                </p>
            )}

            {/* extra description */}
            {Description && (
                <p className='textsm text-neutral-700'>
                    {Description}
                </p>
            )}
        </div>
    )
}

export default React.memo(SuccessMessagePopupCard);